import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RequestStatus } from 'store/request-status/models';
import { LevelMoveEligibility } from 'store/level-move/models';
import { buildHeaders, XmStore } from 'core/services';
import { ModelBase } from 'store/model-base';
import { StoreAction } from 'store/actions';
import { ApiChannel } from 'core/constants';
import { LevelMoveOrderReview } from './models/order-review';

@Injectable()
export class LevelMoveApi {
    public static getEligibility(_xmStore: XmStore, http: HttpClient): Observable<LevelMoveEligibility> {
        return http.get('/account/levelmoveeligibility', {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: LevelMoveEligibility) => LevelMoveEligibility.create<LevelMoveEligibility>(response))
        );
    }

    public static postOrderReview(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<LevelMoveOrderReview> {
        return http.post('/xm/billpreview/segmentSwitch', params, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: LevelMoveOrderReview) => LevelMoveOrderReview.create<LevelMoveOrderReview>(response))
        );
    }

    public static postLevelMove(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<RequestStatus> {
        return http.post('/account/level', { level: params.toLevel, ...(params.planOverrides && { planOverrides: params.planOverrides }) }, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: ApiResponse) => RequestStatus.create<RequestStatus>(response))
        );
    }

    public static postSSMLevelMove(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<RequestStatus> {
        return http.post('/xm/post/segmentSwitch', { level: params.toLevel, ...(params.planOverrides && { planOverrides: params.planOverrides }) }, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }),
            params: { ...(params?.trialFeature && { trialFeature: params.trialFeature }) }
        }).pipe(
            map((response: ApiResponse) => RequestStatus.create<RequestStatus>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_LEVEL_MOVE_ELIGIBILITY] = LevelMoveApi.getEligibility;
ModelBase.persistMapping[StoreAction.POST_LEVEL_MOVE_ORDER_REVIEW] = LevelMoveApi.postOrderReview;
ModelBase.persistMapping[StoreAction.POST_LEVEL_MOVE] = LevelMoveApi.postLevelMove;
ModelBase.persistMapping[StoreAction.POST_SSM_LEVEL_MOVE] = LevelMoveApi.postSSMLevelMove;
